import VenueMap from './VenueMap'
export default VenueMap